module.exports = "<!-- Place all UI elements intended to be present across all routes in this file -->\n<div class=\"p-sticky__body app\">\n  <div class=\"p-sticky__content\">\n    <navbar></navbar>\n    <div ui-view class=\"st-container-fluid\"></div>\n  </div>\n  <footer class=\"o-footer\">\n  </footer>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/app.html
// module id = 197
// module chunks = 0